module.exports = require('./helpers/bundle-url').getBundleURL('cuAka') + "logo-dark.ba5147f0.svg";